import React, { useEffect } from 'react'
import {  useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Formik, Form} from 'formik'
import FormLayout from '../../components/From Layout/FormLayout'
import InputBox from '../../components/Form Components/InputBox/InputBox'
import lockIcon from '../../assets/images/lock.svg'
import Button from '../../components/Form Components/Button'
import "./EnterPassword.scss"
import * as routes from '../../routes/route'
import {ReactComponent as Arrow} from "../../assets/images/arrow-left.svg"
import { enterPassword } from '../../redux/actions/AuthActions/PasswordAction'
import { forgotPassword } from '../../redux/actions/AuthActions/ForgotPasswordAction'
import { formTypes } from '../../const/constants'
import { CircularProgress } from '@mui/material'


function EnterPassword() {
  const loadingPasswordRes = useSelector(state=> state.passwordReducer.loading)
  const {loginData} = useSelector(state=> state.loginReducer)
  const {loading, forgotPasswordData} = useSelector(state=> state.forgotPasswordReducer)
  let data =  forgotPasswordData || loginData;
  const isLogin = localStorage.getItem("UDID")

  const dispatch = useDispatch();
  const navigate = useNavigate()

  const handleForgotPassword = ()=>{
    dispatch(forgotPassword({
      "otp_for": "email",
      "email_id": loginData.email,
      "type": formTypes.FORGOT_PASSWORD,
      navigate
    }))
  }

  useEffect(()=>{
    if(isLogin)
      navigate(-1)
    else if(!data)
        navigate(routes.LOGIN_WITH_EMAIL_ENDPOINT)
  }, [])
  

  //on direct accessing the url 
  if(!data || isLogin)
    return null;

  return (
    <div className="create-password-form">
      <FormLayout title="Enter Your Password">
        <Formik
          initialValues={{ password: ''}}
          onSubmit={async(values,  { resetForm })=>{
            // resetForm()
            dispatch(enterPassword({
              ...values,
              ...data,
            }))                         
          }}
        >
          {
            (formik)=>{
              return (
                <Form name="login">
                  <div className="input-container mt-3">
                    <InputBox type="password" name="password" autoFocus={false} placeholder="Enter Password" iconwidth={'19px'} icon={lockIcon}/>
                  </div>

                  <div className="navigation">
                    <div className="text-end">
                      {/* <Link end="true" to={routes.LOGIN_WITH_MOBILE_ENDPOINT}>Login via Mobile Number</Link> */}
                    </div>
                    <div className="text-center">
                      <div className='d-flex align-items-center justify-content-between mt-1'>
                        <div className='text-primary fw-semi-bold d-flex align-items-center cursor-pointer' onClick={()=>navigate(-1)}><Arrow fill='#0d6efd' width={'13px'}/> &nbsp; Back</div>
                        <Button loading={loadingPasswordRes} width={'100px'} content="verify" type="submit" disabled={!(formik.dirty && formik.isValid) || loadingPasswordRes}/>
                      </div>
                    </div>
                    <div className='justify-content-center d-flex forgot-password mt-4'>
                      <span>Forgot Password? </span>
                      &nbsp;
                      <div className='text-primary cursor-pointer' onClick={handleForgotPassword}>Click here</div>
                    </div>
                  </div>
                  {
                    loading &&
                    <div style={{backgroundColor: "#4a494a36"}} className='position-fixed vw-100 vh-100 d-flex justify-content-center align-items-center top-0 start-0'>
                        <CircularProgress size={40} sx={{'color': '#74613C'}}/>
                    </div>
                  }
                </Form>
              )
            }
          }
        </Formik>
      </FormLayout>
    </div>
  )
}

export default EnterPassword